import classNames from 'classnames'
import { useButtonState } from '../modules/BuilderButtonStateContext'
import { BUILDER_BUTTON_SIZE, BUILDER_BUTTON_SIZE_KEY, BUILDER_BUTTON_TYPE, BUILDER_BUTTON_TYPE_KEY } from '../types'

// FIXME: 로딩 아이콘이 여러 개 뜬다. Icon이나 Label이 여러개 있는 경우, 그 개수만큼 loading 아이콘이 뜬다.
const BuilderButtonLoading = () => {
  const { size, type } = useButtonState()

  return (
    <div className={`flex h-full w-full items-center justify-center`}>
      <div
        className={classNames(
          `animate-[spin_1.5s_linear_infinite] rounded-[50%] border-[2px] border-transparent`,
          styles.color(type),
          styles.size(size)
        )}
      />
    </div>
  )
}

export default BuilderButtonLoading

const styles = {
  color: (type: BUILDER_BUTTON_TYPE_KEY) =>
    classNames(
      type === BUILDER_BUTTON_TYPE.SOLID && `border-t-white border-r-white`,
      type === BUILDER_BUTTON_TYPE.OUTLINE && `border-t-purple-600 border-r-purple-600`,
      type === BUILDER_BUTTON_TYPE.OUTLINE_GRAY && `border-t-gray-200 border-r-gray-200`
    ),
  size: (size: BUILDER_BUTTON_SIZE_KEY) =>
    classNames(
      size === BUILDER_BUTTON_SIZE.XS && `h-[16px] w-[16px]`,
      size === BUILDER_BUTTON_SIZE.SM && `h-[20px] w-[20px]`,
      size === BUILDER_BUTTON_SIZE.MD && `h-[24px] w-[24px]`,
      size === BUILDER_BUTTON_SIZE.LG && `h-[32px] w-[32px]`,
      size === BUILDER_BUTTON_SIZE.XL && `h-[32px] w-[32px]`
    ),
}
